import { FieldType } from '@esri/arcgis-rest-request';
import { DateCellRenderer } from '../components/GridComponents';

type EsriTypeInfo = {
  name: string;
  icon: string;
  type: 'string' | 'number' | 'date';
  description?: string;
  formatter?: CellRenderer;
};

export const esriTypeLookup: Record<FieldType, EsriTypeInfo> = {
  esriFieldTypeSmallInteger: {
    name: 'Small Integer',
    icon: 'number',
    type: 'number',
    description:
      'A 16-bit signed integer. Range: -32768 to 32767. Maximum length: 5 characters.',
  },
  esriFieldTypeInteger: {
    name: 'Integer',
    icon: 'number',
    type: 'number',
    description:
      'A 32-bit signed integer. Range: -2147483648 to 2147483647. Maximum length: 10 characters.',
  },
  esriFieldTypeSingle: {
    name: 'Float',
    icon: 'number',
    type: 'number',
    description:
      'A 32-bit floating point number. Range: -3.4e38 to 3.4e38. Maximum length: 14 characters.',
  },
  esriFieldTypeDouble: {
    name: 'Double',
    icon: 'number',
    type: 'number',
    description:
      'A 64-bit floating point number. Range: -2.2E308 to 1.8E308. Maximum length: 16 characters.',
  },
  esriFieldTypeString: {
    name: 'String',
    icon: 'string',
    type: 'string',
    description:
      'A string of characters. Maximum length is defined by the field length property.',
  },
  esriFieldTypeDate: {
    name: 'Date',
    icon: 'calendar',
    type: 'date',
    description:
      'The date data type can store dates, times, or dates and times. The default format in which the information is presented is mm/dd/yyyy hh:mm:ss and a specification of AM or PM.',
    formatter: DateCellRenderer,
  },
  esriFieldTypeOID: {
    name: 'OID',
    icon: 'number',
    type: 'number',
  },
  esriFieldTypeGeometry: {
    name: 'Geometry',
    icon: 'map',
    type: 'string',
  },
  esriFieldTypeBlob: {
    name: 'Blob',
    icon: 'text',
    type: 'string',
  },
  esriFieldTypeRaster: {
    name: 'Raster',
    icon: 'map',
    type: 'string',
  },
  esriFieldTypeGUID: {
    name: 'GUID',
    icon: 'text',
    type: 'string',
  },
  esriFieldTypeGlobalID: {
    name: 'Global ID',
    icon: 'text',
    type: 'string',
  },
  esriFieldTypeXML: {
    name: 'XML',
    icon: 'text',
    type: 'string',
  },
};
